async function searchSwitchParse(search, searchGroupName){
    //console.log(searchGroupName)
    if(searchGroupName){
      return {[searchGroupName]: search} 
    }

    let house_plus_letter, house_plus_letter2;
    search = search.replace(/\s+/g, ' ').trim() // Убираем лишние пробелы
    if (search.match(/ /g)){ // Если несколько слов
      let result = search.split(' ')
      
      if(result[0].match(/^-{0,1}\d+$/)){ // Если в первом слове только цифры
        this.prefixSearch = 'по адресі: '
          
        if (result.length == 2) {
          house_plus_letter = result[0].match(/(^[0-9]+)([А-я]$)/i) 
          if (house_plus_letter){ // Если найдено слитное "дом + буква"
            //return {house: house_plus_letter[1], letter: house_plus_letter[2], flat: result[1]}
          }
          else if (result[1].match(/^-{0,1}\d+$/)){ // Если второе слово из цифр
            //return {house: result[0], flat: result[1]} 
          } 
          else return {house: result[0], letter: result[1]} 
        }
        
      }else { // Если в первом слове не только цифры
        this.prefixSearch = 'по адресі: '
        
        if (result.length == 3){
          house_plus_letter = result[1].match(/(^[0-9]+)([А-я]$)/i)
          if (house_plus_letter){ // Если найдено слитное "дом + буква"
            //return {street_str: result[0], house: house_plus_letter[1], letter: house_plus_letter[2], flat: result[2]}
          }
          else if (result[2].match(/^-{0,1}\d+$/)){ // Если третье слово из цифр
            //return {street_str: result[0], house: result[1], flat: result[2]}
            }
          else {// Если третье слово из букв
            return {street_id: await this.searchStreetId(result[0]), house: result[1], letter: result[2]} 
          }
          
        }
        else if (result.length == 2) {
          house_plus_letter = result[0].match(/(^[0-9]+)([А-я]$)/i) 
          house_plus_letter2 = result[1].match(/(^[0-9]+)([А-я]$)/i) 
          if(house_plus_letter){ // Если в первом слове найдено слитное "дом + буква"
            //return {house: house_plus_letter[1], letter: house_plus_letter[2], flat: result[1]} 
          }else if (house_plus_letter2){// Если во втором слове найдено слитное "дом + буква"
            return {street_id: await this.searchStreetId(result[0]), house: house_plus_letter2[1], letter: house_plus_letter2[2]}
          }else return {street_id: await this.searchStreetId(result[0]), house: result[1]}
        } 
        
      }
    }else{ // Если одно слово
      if (search.match(/^-{0,1}\+*\d+$/)) { // Если в слове только цифры match(/^-{0,1}\d+$/)
        if(4 > search.length && search.length > 0 ) { // 
          this.prefixSearch = 'по будинку: '
          return { house: search }
        }
        else{
          this.prefixSearch = 'інше: '
          return { search: search }
        }
      } 
      else { // Якщо в слові не тільки цифри
        house_plus_letter = search.match(/(^[0-9]+)([А-я]$)/i)
        if (house_plus_letter){ // Если найдено слитное "дом + буква"
          return {house: house_plus_letter[1], letter: house_plus_letter[2]}
        }
        else if(search.match(/^[0-9a-f]{2}((-|:)[0-9a-f]{2}){5}$/i)){ // Якщо знайдено мак адресу
          this.prefixSearch = 'по mac: '
          return { mac: search }
        }
        else if(search.match(/\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\b/g)){ // Якщо знайдено IP адресу
          this.prefixSearch = 'по IP: '
          return { ip: search }
        }
        this.prefixSearch = 'інше: '
        return { search: search }
      }
      
    }
  }

  export default searchSwitchParse